import { IRow, MemoizedBasicTable, StringNumberArrayType } from 'components/Table/BasicTable';
import React, { useMemo } from 'react';
import { OfferingPoolResponseType } from 'store/reducers/temple/offeringPoolSlice';
import { IOfferingCategoryResponse } from 'types/api/temple';

interface OfferingPoolTableProps {
    editHandler?: ((id: string | number ) => void | Promise<any>) & Function,
    deleteHandler?: ((id: string | number) => void | Promise<any>) & Function,
    deletingIds?: StringNumberArrayType,
    offeringPools: OfferingPoolResponseType[]
}

const getRows = (offeringCategories: OfferingPoolResponseType[]): IRow[] => {
    let rows: IRow[] = []
    offeringCategories.forEach(pool => {
        rows.push({
            id: pool.url,
            values: [pool.poolName, pool.poolLimit]
        })
    })
    return rows
}

const OfferingPoolTable: React.FC<OfferingPoolTableProps> = ({ editHandler, deleteHandler, deletingIds, offeringPools }) => {
    const rows = useMemo(() => getRows(offeringPools), [offeringPools])
    return (
        <MemoizedBasicTable
            rows={rows}
            headRow={['common.name', 'offeringPool.limit']}
            editHandler={editHandler}
            deleteHandler={deleteHandler}
            deletingIds={deletingIds}
        />
    );
};

export default OfferingPoolTable;